/** Colours shared by the pill and the pane tint that echoes it. */
const MODE_COLORS = {
  arrival: { pill: '#22c55e', tint: '#bbf7d0' },
  departure: { pill: '#f97316', tint: '#fed7aa' },
} as const;
export const modeColors = (mode?: string | null) => (mode === 'departure' ? MODE_COLORS.departure : MODE_COLORS.arrival);

